(function () {
  var frame;
  var controls = new WeakMap();

  function formatter() {
    var value = window.LucceCurrencyFormatter;
    return value && value.isCurrencyReady() ? value : null;
  }

  function refresh(force) {
    var currency = formatter();
    if (!currency) return;
    document.querySelectorAll('.gf-range-slider[aria-label="Price"]').forEach(function (slider) {
      var box = slider.parentElement;
      var api = slider.noUiSlider;
      if (!api) return;
      var pair = controls.get(slider);
      if (!pair) {
        var originals = [box.querySelector('.gf-range-min'), box.querySelector('.gf-range-max')];
        if (originals.some(function (input) { return !input; })) return;
        pair = originals.map(function (original, index) {
          var input = original.cloneNode(false);
          input.id = original.id + '-currency';
          input.className = 'lucce-price-range-input';
          input.style.cssText = 'width:calc(50% - 16px);min-width:0;padding:8px;border:1px solid #ddd;';
          input.dataset.priceLabel = original.getAttribute('aria-label') || 'Price';
          input.removeAttribute('data-value');
          input.removeAttribute('data-min-value');
          input.removeAttribute('data-max-value');
          input.setAttribute('inputmode', 'decimal');
          original.hidden = true;
          original.style.display = 'none';
          original.insertAdjacentElement('afterend', input);
          var label = box.querySelector('label[for="' + original.id + '"]');
          if (label) label.htmlFor = input.id;
          input.addEventListener('input', function (event) { event.stopPropagation(); });
          input.addEventListener('change', function (event) {
            event.stopPropagation();
            var active = formatter();
            var amount = Number(input.value.replace(/,/g, '').trim());
            if (!active || !input.value.trim() || !Number.isFinite(amount) || amount < 0) {
              input.dataset.dirty = '';
              if (active) input.value = String(active.phpToSelectedAmount(Number(api.get(true)[index])));
              return;
            }
            var values = api.get(true).map(Number);
            var php = active.selectedToPhpAmount(amount);
            var min = Number(slider.dataset.min);
            var max = Number(slider.dataset.max);
            php = Math.max(min, Math.min(max, php));
            php = index === 0 ? Math.min(php, values[1]) : Math.max(php, values[0]);
            values[index] = Math.round(php * 100) / 100;
            api.set(values, false);
            var appliedValues = api.get(true).map(Number);
            originals.forEach(function (field, fieldIndex) {
              field.value = String(appliedValues[fieldIndex]);
            });
            input.dataset.dirty = '';
            original.dispatchEvent(new Event('change', { bubbles: true }));
            schedule();
          });
          input.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
              event.preventDefault();
              input.blur();
            }
          });
          input.addEventListener('input', function () { input.dataset.dirty = 'true'; });
          return input;
        });
        controls.set(slider, pair);
        api.on('update.lucceCurrency', schedule);
      }
      var state = currency.getState();
      var code = state ? state.code : 'PHP';
      var values = api.get(true).map(Number);
      pair.forEach(function (input, index) {
        var currencyChanged = input.dataset.currency && input.dataset.currency !== code;
        if (currencyChanged || (document.activeElement !== input && input.dataset.dirty !== 'true')) {
          input.value = String(currency.phpToSelectedAmount(values[index]));
          input.dataset.dirty = '';
        }
        input.dataset.currency = code;
        input.setAttribute('aria-label', input.dataset.priceLabel + ' (' + code + ')');
        input.removeAttribute('aria-labelledby');
      });
      slider.querySelectorAll('.noUi-value[data-value]').forEach(function (pip) {
        var text = currency.formatPhpPrice(Number(pip.dataset.value));
        if (pip.textContent !== text || pip.querySelector('.money')) pip.textContent = text;
      });
      slider.querySelectorAll('[role="slider"]').forEach(function (handle, index) {
        handle.setAttribute('aria-valuetext', currency.formatPhpPrice(values[index]));
      });
    });
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      refresh(false);
    });
  }

  function init() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('lucce:currency:updated', function () { refresh(true); });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
